import {Component} from '@stencil/core';

@Component({
  scoped: true,
  styleUrl: 'igws-link-wrapper.less',
  tag: 'igws-link-wrapper',
})
export class LinkWrapperComponent {
  render() {}
}
